import React, { Fragment, useEffect, useState, } from 'react'
import NotificationsBlock from './Notifications_block'
import { useDispatch, useSelector } from 'react-redux'
import { deleteAllNotifcationsAction, getnotifcationsAction, markAllAsReadAction } from '../../redux/actions/notificationsActions'
import { socket } from "../../utils/socket.js"
import Img1 from "../images/bell.png"
import dayjs from 'dayjs';




const Notifications = () => {


    const dispatch = useDispatch()
    const { unread_count, notifications, count, totalPages, urgent_count } = useSelector(state => state.notifications)
    const { loading, message } = useSelector(state => state.marknotifications)




    const [page, setPage] = useState(1)
    const [type, setType] = useState("")
    const [notify_type, setNotify_type] = useState("")
    const perPage = 20



    useEffect(() => {

        const query = {}
        if (type) {
            query.type = type
        }
        if (notify_type) {
            query.notify_type = notify_type
        }
        query.perPage = perPage || 20
        query.page = page || 1



        dispatch(getnotifcationsAction(query))

    }, [dispatch, perPage, page, type, notify_type])



    useEffect(() => {

        if (message) {
            const query = {}
            if (type) {
                query.type = type
            }
            if (notify_type) {
                query.notify_type = notify_type
            }
            query.perPage = perPage || 20
            query.page = page || 1

            dispatch(getnotifcationsAction(query))
            dispatch({ type: "MARK_NOTIFICATIONS_RESET" })
        }

    }, [dispatch, message, perPage, notify_type, type, page])



    useEffect(() => {
        const handleNotification = (data) => {
            const query = {}

            if (type) {
                query.type = type
            }
            if (notify_type) {
                query.notify_type = notify_type
            }
            query.perPage = perPage || 20
            query.page = page || 1

            dispatch(getnotifcationsAction(query))
        };

        socket.on("new_notification", handleNotification);

        return () => {
            socket.off("new_notification", handleNotification);
        };
    }, [dispatch, perPage, notify_type, page, type]);


   const { todayNotifications, yesterdayNotifications, earlierNotifications } = React.useMemo(() => {
  
          const today = []
          const yesterday = []
          const earlier = []
  
          const now = dayjs()
  
          notifications?.forEach((n) => {
  
              const date = dayjs(n.created_at)
  
              if (date.isSame(now, 'day')) {
                  today.push(n)
              } else if (date.isSame(now.subtract(1, 'day'), 'day')) {
                  yesterday.push(n)
              } else {
                  earlier.push(n)
              }
          })
  
          return {
              todayNotifications: today,
              yesterdayNotifications: yesterday,
              earlierNotifications: earlier
          }
  
      }, [notifications])
  
  

    useEffect(() => {
        setPage(1)
    }, [type, notify_type])






    const markAllAsRead = () => {
        dispatch(markAllAsReadAction())
    }

    const deleteAll = () => {
        dispatch(deleteAllNotifcationsAction())
    }

    return (
        <Fragment>
            <div className="   mb-[1vmax] bg-white shadow-1 rounded-xl p-[2vmax] m-[1vmax_2vmax]">
                <div className="w-[100%] flex gap-[1vmax] items-center flex-wrap ">
                    <img src={Img1} alt="" className='w-[3vmax]' />
                    <div className="lg:w-1/2">
                        <h3 className='font-bold lg:text-[1.3vmax] font-3' >All Notifications</h3>
                        <p className='text-gray-500 text-[1.6vmax] lg:text-[0.9vmax]' >
                            Stay updated with all the important activities.
                        </p>
                    </div>
                    <div className="w-full lg:w-[50%] flex justify-end items-center  gap-[1.5vmax] ">
                        <button className='bg-white shadow-lg lg:text-[1vmax] text-[var(--color-3)] rounded-xl p-[0.8vmax_1.5vmax] cursor-pointer hover:scale-95'
                            onClick={() => markAllAsRead()}
                            disabled={loading}
                        >
                            <i className="fa-regular fa-check-circle"></i>
                            &nbsp;&nbsp;
                            Mark all as Read
                        </button>
                        <button className='bg-white shadow-lg lg:text-[1vmax] text-red-500 rounded-xl p-[0.8vmax_1.5vmax] cursor-pointer hover:scale-95'
                            onClick={() => deleteAll()}
                            disabled={loading}

                        >
                            <i className="fa-solid fa-trash"></i>
                            &nbsp;&nbsp;
                            Delete All
                        </button>
                    </div>
                </div>


            </div>
            <div className="flex justify-end">
                <div className="grid grid-cols-[1fr_1fr_1fr] gap-[1vmax] lg:text-[0.9vmax] p-[1vmax_2vmax]  lg:w-[40%]">
                    <div className={`flex justify-between items-center  rounded-xl p-[0.5vmax_0.5vmax]  shadow-xl cursor-pointer hover:scale-95 ${type === "" && notify_type === "" ? "bg-[image:var(--gradient-circle)] text-white" : "bg-white"}`}
                        onClick={() => {
                            setType("")
                            setNotify_type("")
                            setPage(1)
                        }}
                    >
                        <span>All</span>
                        <span className='inline-block w-[2vmax] text-center bg-slate-200 p-[0.2vmax_0.3vmax] rounded-lg text-[var(--color-3)] shadow-3' >{count || 0}</span>
                    </div>
                    <div className={`flex justify-between items-center  rounded-xl p-[0.5vmax_0.5vmax]  shadow-xl cursor-pointer hover:scale-95 ${type === "" && notify_type === "unread" ? "bg-[image:var(--gradient-circle)] text-white" : "bg-white"}`}
                        onClick={() => {
                            setType("")
                            setNotify_type("unread")
                            setPage(1)

                        }}
                    >
                        <span>Unread</span>
                        <span className='inline-block w-[2vmax] text-center bg-slate-200 p-[0.2vmax_0.3vmax] rounded-lg text-[var(--color-3)] shadow-3' >{Number(unread_count) > 99 ? "99+" : unread_count || 0}

                        </span>
                    </div>
                    <div className={`flex justify-between items-center  rounded-xl p-[0.5vmax_0.5vmax]  shadow-xl cursor-pointer hover:scale-95 ${type === "WARNING" && notify_type === "" ? "bg-[image:var(--gradient-circle)] text-white" : "bg-white"}`}
                        onClick={() => {
                            setType("WARNING")
                            setNotify_type("")
                            setPage(1)
                        }}
                    >
                        <span>Urgent</span>
                        <span className='inline-block w-[2vmax] text-center bg-slate-200 p-[0.2vmax_0.3vmax] rounded-lg text-[var(--color-3)] shadow-3' >{Number(urgent_count) > 99 ? "99+" : urgent_count || 0}</span>
                    </div>
                </div>
            </div>
            <section className="p-[1.5vmax] w-full  mx-auto">
                <div className="  rounded-xl p-[2vmax]">
                    <div className=" ">
                        <div className=" relative" >

                            <div className="">
                                {notifications?.length === 0 && (
                                    <div className="text-[1.2vmax] font-3 text-gray-600 flex-center h-[5vmax]">
                                        No notifications to show
                                    </div>
                                )}

                                {/* TODAY */}
                                {todayNotifications.length > 0 && (
                                    <>
                                        <div className="grid grid-cols-[0.3fr_9fr] gap-[2vmax]">
                                            <div className="flex justify-start items-center flex-col relative">
                                                <div className="w-[0.8vmax] aspect-square rounded-full bg-[var(--color-3)] relative z-[99]">
                                                    <span className="bg-[#5f2dde2c] inline-block  aspect-square rounded-full absolute inset-[-0.3vmax] z-[99]" >

                                                    </span>
                                                </div>
                                                <div className=" w-[0.1vmax] h-full absolute top-0 left-[calc(50%-0.05vmax)] bg-gray-300">

                                                </div>

                                            </div>

                                            <div className=" pb-[3vmax]">

                                                <h4 className="text-[1vmax] font-bold text-gray-500  translate-x-[-1.5vmax] mt-[-0.3vmax] pb-[3vmax]">
                                                    Today
                                                </h4>
                                                {todayNotifications.map((n, i) => (
                                                    <NotificationsBlock key={i} notification={n} />
                                                ))}
                                            </div>
                                        </div>
                                    </>
                                )}

                                {/* YESTERDAY */}
                                {yesterdayNotifications.length > 0 && (
                                    <>
                                        <div className="grid grid-cols-[0.3fr_9fr] gap-[2vmax] ">
                                            <div className="flex justify-start items-center flex-col relative">
                                                <div className="w-[0.8vmax] aspect-square rounded-full bg-[var(--color-3)] relative z-[99]">
                                                    <span className="bg-[#5f2dde2c] inline-block  aspect-square rounded-full absolute inset-[-0.3vmax] z-[99]" >

                                                    </span>
                                                </div>
                                                <div className=" w-[0.1vmax] h-full absolute top-0 left-[calc(50%-0.05vmax)] bg-gray-300">

                                                </div>

                                            </div>

                                            <div className=" pb-[3vmax]">

                                                <h4 className="text-[1vmax] font-bold text-gray-500  translate-x-[-1.5vmax] mt-[-0.3vmax] pb-[3vmax]">
                                                    Yesterday
                                                </h4>
                                                {yesterdayNotifications.map((n, i) => (
                                                    <NotificationsBlock key={i} notification={n} />
                                                ))}
                                            </div>

                                        </div>

                                    </>
                                )}

                                {/* EARLIER */}
                                {earlierNotifications.length > 0 && (
                                    <>
                                        <div className="grid grid-cols-[0.3fr_9fr] gap-[2vmax]">
                                            <div className="flex justify-start items-center flex-col relative">
                                                <div className="w-[0.8vmax] aspect-square rounded-full bg-[var(--color-3)] relative z-[99]">
                                                    <span className="bg-[#5f2dde2c] inline-block  aspect-square rounded-full absolute inset-[-0.3vmax] z-[99]" >

                                                    </span>
                                                </div>
                                                <div className=" w-[0.1vmax] h-full absolute top-0 left-[calc(50%-0.05vmax)] bg-gray-300">

                                                </div>

                                            </div>

                                            <div className="pb-[3vmax] ">

                                                <h4 className="text-[1vmax] font-bold text-gray-500  translate-x-[-1.5vmax] mt-[-0.3vmax] pb-[3vmax]">

                                                    Earlier
                                                </h4>
                                                {earlierNotifications.map((n, i) => (
                                                    <NotificationsBlock key={i} notification={n} />
                                                ))}
                                            </div>
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {totalPages > 1 && (
                <div className="flex gap-[1vmax] justify-center mt-[2vmax]">

                    {/* Prev button */}
                    <button
                        className="pagination-btn"
                        disabled={page === 1}
                        onClick={() => setPage(page - 1)}
                    >
                        Prev
                    </button>

                    {/* --- SMART PAGINATION START --- */}
                    {(() => {
                        const pages = [];
                        const maxVisible = 3; // number of pages to show around current page

                        const addPage = (p) => {
                            pages.push(
                                <button
                                    key={p}
                                    className={`pagination-btn ${page === p ? "active" : ""}`}
                                    onClick={() => setPage(p)}
                                >
                                    {p}
                                </button>
                            );
                        };

                        // Always show First Page
                        addPage(1);

                        // Left dots
                        if (page > maxVisible + 2) {
                            pages.push(<span key="dots-left">...</span>);
                        }

                        // Middle pages (dynamic)
                        for (
                            let p = Math.max(2, page - maxVisible);
                            p <= Math.min(totalPages - 1, page + maxVisible);
                            p++
                        ) {
                            addPage(p);
                        }

                        // Right dots
                        if (page < totalPages - (maxVisible + 1)) {
                            pages.push(<span key="dots-right">...</span>);
                        }

                        // Always show Last Page
                        if (totalPages > 1) {
                            addPage(totalPages);
                        }

                        return pages;
                    })()}
                    {/* --- SMART PAGINATION END --- */}

                    {/* Next button */}
                    <button
                        className="pagination-btn"
                        disabled={page === totalPages}
                        onClick={() => setPage(page + 1)}
                    >
                        Next
                    </button>

                </div>
            )}
            <br />
            <br />
            <br />
            <br />

        </Fragment>
    )
}

export default Notifications